import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FRM_67 } from "@/lib/programs/marrakechFez67";

export default function MarrakechFez67Page() {
  return <ProgramTemplate program={PROGRAM_FRM_67} variant="frm" showJourneyChronology />;
}
